import { render, staticRenderFns } from "./MultiLinkToAnchor.vue?vue&type=template&id=30d63827&"
import script from "./MultiLinkToAnchor.vue?vue&type=script&lang=js&"
export * from "./MultiLinkToAnchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports